// eslint-disable-next-line import/no-anonymous-default-export
export default {
  serverName: process.env.REACT_APP_SERVERNAME,
  mainDir: process.env.REACT_APP_MAINDIR,
  clientId: process.env.REACT_APP_CLIENTID,
  apiUrl: process.env.REACT_APP_APIURL,
  baseApiUrl: process.env.REACT_APP_BASEAPIURL,
  baseUrl: process.env.REACT_APP_BASEURL,
  site: {
    home: process.env.REACT_APP_SITE_HOME,
    team: process.env.REACT_APP_SITE_TEAM,
    teamWaiting: process.env.REACT_APP_SITE_TEAMWAITING,
  },
};
